module.exports = __webpack_public_path__ + "static/media/easy-padaria.85f85a2e.png";